'use client';

import { createContext } from 'app/libs/createContext';
import { type UseCartReturn } from './useCart';

export const [CartProvider, useCartContext, CartContext] = createContext<UseCartReturn>({
    name: 'CartContext',
});
